// @flow
import CentenaireAssociesContainer from 'components/centenaire/CentenaireAssocies';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/centenaire/CentenaireAssocies';
import { fetchCentenaireDocuments } from 'actions/centenaireActions';

export default connect(
  (state: StateType): StateProps => ({
    documents: state.centenaireState.documents,
    statusDocuments: state.centenaireState.status,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchCentenaireDocuments: (data: Object) => dispatch(fetchCentenaireDocuments(data)),
  })
)(CentenaireAssociesContainer);
